export default __webpack_public_path__ + "images/IA.34bf281.png";